import React, { useState } from "react";
import {
  Box,
  Container,
  Dialog,
  DialogTitle,
  DialogContent,
  FormControl,
  Grid,
  Paper,
  IconButton,
  InputAdornment,
  TextField,
  Button,
  Typography,
} from "@mui/material";
import moment from "moment";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import currency from "currency.js";
import BDatePicker from "../input/BDatePicker";
import PaymentDue from "../../order/component/PaymentDue";
import SameDayPaymentDueWarning from "../../order/component/SameDayPaymentDueWarning";
import { getDefaultBalanceDueDate } from "../util";
import AttachMoneyOutlinedIcon from "@mui/icons-material/AttachMoneyOutlined";
export default function AddDeposit(props) {
  const { fulfillment, paymentSummary } = props;

  const [deposit, setDeposit] = useState("");
  const [dueDate, setDueDate] = useState("");

  const [open, setOpen] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    props.onChange({ deposit, dueDate });
    handleClose();
  };

  const handleClose = () => {
    setOpen(false);
    setDeposit("");
    setDueDate("");
  };

  const button = (
    <Button
      color={props.required ? "error" : "primary"}
      size="small"
      onClick={(e) => {
        if (paymentSummary.due !== paymentSummary.total) {
          setDeposit(paymentSummary.due);
          setDueDate(props.dueDate);
        } else {
          setDeposit("");
          setDueDate(getDefaultBalanceDueDate(fulfillment.date));
        }

        setOpen(true);
      }}
    >
      + Deposit
    </Button>
  );

  return (
    <>
      <Grid container spacing={1} alignItems="center">
        <Grid item xs={9}>
          {button}
        </Grid>
        <Grid item xs={3} align="right"></Grid>
      </Grid>
      <Box pt={1} mt={1} sx={{ borderTop: "1px solid #ECECEC" }}>
        <PaymentDue total={paymentSummary.total} due={paymentSummary.due} dueDate={props.dueDate} />
      </Box>
      <Dialog fullScreen={true} open={open} scroll="paper" onClose={handleClose}>
        <DialogTitle
          sx={{
            padding: "7px 20px",
            display: "flex",
            gap: "10px",
            justifyContent: "space-between",
            alignItems: "center",
            margin: "0",
            backgroundColor: "#DEDEDE",
            borderBottom: "3px solid #DEDEDE",
          }}
        >
          <IconButton onClick={handleClose}>
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h5">Deposit & Balance Payment</Typography>
          <Box>
            <Button
              color="primary"
              variant="contained"
              type="submit"
              form="add-deposit-form"
              disabled={+deposit >= +paymentSummary.total}
            >
              SUBMIT
            </Button>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ backgroundColor: "#F7F7F7" }}>
          <Container maxWidth="xs">
            <Box py={4}>
              <Paper elevation={0}>
                <form id="add-deposit-form" onSubmit={handleSubmit}>
                  <Box px={2} py={4}>
                    <TextField
                      id="deposit"
                      type="number"
                      value={deposit}
                      label="Deposit Amount"
                      name="deposit"
                      variant="outlined"
                      fullWidth
                      required
                      onChange={(e) => setDeposit(e.target.value)}
                      onWheel={(e) => {
                        e.target && e.target.blur();
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyOutlinedIcon />
                          </InputAdornment>
                        ),
                      }}
                      error={+deposit >= +paymentSummary.total}
                      helperText={
                        +deposit >= +paymentSummary.total
                          ? `Deposit amount should be less than ${currency(paymentSummary.total).format()}`
                          : ""
                      }
                    />
                    <Box mt={3}>
                      <FormControl variant="outlined" fullWidth>
                        <BDatePicker
                          label="Balance Due Date"
                          value={dueDate}
                          onChange={(d) => setDueDate(d)}
                          disablePast
                          maxDate={
                            fulfillment.date
                              ? moment(fulfillment.date, "YYYY-MM-DD").toDate()
                              : undefined
                          }
                          required
                          autoOk
                        />
                      </FormControl>
                      <SameDayPaymentDueWarning
                        dueDate={dueDate}
                        fulfillmentDate={fulfillment.date}
                        customerType={props.customerType}
                      />
                    </Box>
                  </Box>
                </form>
              </Paper>
            </Box>
          </Container>
        </DialogContent>
      </Dialog>
    </>
  );
}
